import { useState } from 'react';
import LanguageStore from '../../store/LanguageStore';
import { observer } from 'mobx-react-lite';
import './game-mode-selector.scss';

const GameModeSelector = observer(({ onSinglePlayer, onMultiPlayer, onClose }) => {
    const t = LanguageStore.t;

    return (
        <div className="game-mode-selector">
            <div className="game-mode-selector__modal">
                <div className="game-mode-selector__content">
                    <button 
                        className="game-mode-selector__close-button"
                        onClick={onClose}
                        aria-label={t('close')}
                    >
                        ×
                    </button>
                    <h2 className="game-mode-selector__title">{t('selectGameMode')}</h2>
                    <p className="game-mode-selector__description">{t('selectGameModeDescription')}</p>
                    <div className="game-mode-selector__options">
                        <button 
                            className="game-mode-selector__option"
                            onClick={onSinglePlayer}
                        >
                            <span className="game-mode-selector__option-icon">👤</span>
                            <span className="game-mode-selector__option-title">{t('singlePlayer')}</span>
                            <span className="game-mode-selector__option-description">{t('singlePlayerDescription')}</span>
                        </button>
                        <button 
                            className="game-mode-selector__option game-mode-selector__option--multiplayer"
                            onClick={onMultiPlayer}
                        >
                            <span className="game-mode-selector__option-icon">👥</span>
                            <span className="game-mode-selector__option-title">{t('multiPlayer')}</span>
                            <span className="game-mode-selector__option-description">{t('multiPlayerDescription')}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default GameModeSelector;

